export const corvidName = '$w.Section';

export const TranslationKeys = {
  pauseLabel: 'TextEffects_MediaButton_Pause',
  playLabel: 'TextEffects_MediaButton_Play',
  ariaLabel: 'TextEffects_MediaButton_AriaLabel',
  namespace: 'ariaLabels',
};
